import { baseApi } from './baseApi';

export const referralAnalyticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReferralAnalyticsOverview: builder.query({
      query: (days = 14) => ({
        url: '/referral-analytics/overview',
        params: { days },
      }),
      providesTags: ['Dashboard'],
    }),
  }),
});

export const { useGetReferralAnalyticsOverviewQuery } = referralAnalyticsApi;
